<div class="rights-reserved">© {{ currentYear }} Planful, Inc. All Rights Reserved.</div>
